import React, { FC } from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

type Props = {
  showModal: boolean;
  onCancel?: () => void;
  deleteReview: (uuid: string) => Promise<void>;
  uuid: string;
};

export const DeleteReviewModal: FC<Props> = ({
  showModal,
  onCancel,
  deleteReview,
  uuid,
}) => {
  const { t } = useTranslation();

  return (
    <Modal show={showModal} onHide={onCancel} centered>
      <Modal.Header className="border-0 text-dark" closeButton>
        <Modal.Title>{t("review.deleteReview")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center text-dark">
        <p className="fs-6 fw-bold">{t("review.description1")}</p>
        <p className="mb-1">{t("review.description2")}</p>
        <p className="mb-4">{t("review.description3")}</p>
        <Row className="gx-2">
          <Col xs={12} sm={6} className="mb-3 mb-lg-0">
            <Button
              variant="primary"
              className=" text-white py-3 w-100"
              onClick={onCancel}
            >
              {t("review.close")}
            </Button>
          </Col>
          <Col xs={12} sm={6}>
            <Button
              variant="outline-primary"
              className="py-3 w-100 fw-bold"
              onClick={async () => {
                await deleteReview(uuid);
                onCancel?.();
              }}
            >
              {t("review.deleteReview")}
            </Button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
